const DEBUG_TRUE_VALUES = new Set(['', '1', 'true', 'yes', 'on', 'debug']);

export const isDebugFlagEnabled = (...keys) => {
  if (typeof window === 'undefined') {
    return false;
  }

  const params = new URLSearchParams(window.location.search);

  return keys.some((key) => {
    if (!params.has(key)) {
      return false;
    }

    const value = params.get(key);
    return DEBUG_TRUE_VALUES.has(String(value ?? '').toLowerCase());
  });
};

export const roundDebugValue = (value, precision = 3) => (
  typeof value === 'number' && Number.isFinite(value)
    ? Number(value.toFixed(precision))
    : value
);

export const getViewportDebugSnapshot = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    visualViewportWidth: roundDebugValue(window.visualViewport?.width ?? null, 2),
    visualViewportHeight: roundDebugValue(window.visualViewport?.height ?? null, 2),
    visualViewportOffsetTop: roundDebugValue(window.visualViewport?.offsetTop ?? null, 2)
  };
};
